import { TSupportMessage } from '@cannect/services/resources/supportChat/types'

/**
 * Depois deste intervalo, o bloco recomeça mesmo sendo a mesma pessoa.
 *
 * Sem isso, uma resposta que chega meia hora depois apareceria colada na
 * anterior, como se fosse a mesma fala.
 */
const BLOCK_BREAK_MS = 5 * 60 * 1000

/**
 * Diz se a mensagem abre um bloco — é o que decide se o nome do remetente
 * aparece, como no WhatsApp.
 */
export const startsNewBlock = (message: TSupportMessage, previous?: TSupportMessage) => {
  if (!previous) return true
  if (previous.sender_type !== message.sender_type) return true
  if (previous.sender_id !== message.sender_id) return true

  return message.created_at - previous.created_at > BLOCK_BREAK_MS
}

/** "Hoje", "Ontem" ou a data — o mesmo critério de qualquer app de mensagem. */
export const dayLabel = (timestamp: number) => {
  if (!timestamp) return null

  const dia = new Date(timestamp)
  const hoje = new Date()
  const ontem = new Date()

  ontem.setDate(hoje.getDate() - 1)

  if (dia.toDateString() === hoje.toDateString()) return 'Hoje'

  if (dia.toDateString() === ontem.toDateString()) return 'Ontem'

  return dia.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

/**
 * Diz se a mensagem abre um dia novo na conversa. O balão só mostra a hora —
 * sem o separador, uma conversa que atravessou três dias parece uma tarde só.
 */
export const startsNewDay = (message: TSupportMessage, previous?: TSupportMessage) =>
  !previous || dayLabel(message.created_at) !== dayLabel(previous.created_at)

export default startsNewBlock
